import type {
  OptionGroupSlots as OptionGroupBaseSlots,
  OptionGroupProps as OptionGroupBaseProps,
  OptionGroupState as OptionGroupBaseState,
} from '@fluentui/react-combobox';

export type OptionGroupSlots = OptionGroupBaseSlots;

/**
 * OptionGroup Props
 */
export type OptionGroupProps = OptionGroupBaseProps;

/**
 * State used in rendering OptionGroup
 */
export type OptionGroupState = OptionGroupBaseState;
